exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1AzFk-7_3_0 {\n  max-height: 300px;\n  max-width: 248px; }\n", ""]);

// Exports
exports.locals = {
	"core-dropdown__overlay": "_1AzFk-7_3_0"
};